import Component from '../component';
import Google from '../../helpers/google';


export default class ToggleFavorite extends Component {
    constructor(...args) {
        super(...args);
        bindAll(this, [
            '_toggleFavorite'
        ]);
        this.uid = uniqueID();

        this._retrieveDOM();
    }

    set active(v) {
        this.dom.component.classList[v ? 'add' : 'remove']( 'active' );
    }

    get active() {
        return this.dom.component.classList.contains('active');
    }

    _retrieveDOM() {
        this.dom.views = {};
        this.dom.views.page = document.body.querySelector('div[data-page][data-entity]');
    }

    init() {

        this._is_process = false;

        this._action = 'candiapro_bookmark';
        this._recipe_id = this.dom.component.getAttribute( 'data-recipe-id' );
        this._user_id = this.dom.views.page.getAttribute( 'target-id' );

        this._data = new FormData();
        this._data.append( 'sub_action', 'toggle' );
        this._data.append( 'recipe_id', this._recipe_id );
        this._data.append( 'user_id', this._user_id );

        // add to dom element
        this.dom.component.toggleFavorite = this;
    }

    bind() {
        super.bind();
        this.dom.component.addEventListener( 'click', this._toggleFavorite );
    }

    _toggleFavorite() {
        if( this._is_process == false ) {
            Google.pushCustomTracker('Favorite', document.URL);
            this._request();
        }

        this._is_process = true;
    }

    _request() {
        const xhr = new XMLHttpRequest();

        xhr.open( 'POST', '/ajax.php?action=' + this._action, true );

        xhr.onreadystatechange = function () {

            if( xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200 ) {
                this._response( JSON.parse( xhr.response ) );
            }
            this._is_process = false;

        }.bind(this);

        xhr.send( this._data );
    }

    _response( response ) {
        if( response.success == true ) {
            this.dom.component.classList.toggle( 'active' );
            this.emit('update', {active:this.active, recipe_id:this._recipe_id});
        }
    }

    /*
    init(top: 25%;) {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/toggle-favorite/toggle-favorite.js